import {WorkerMessage} from './shared/worker-message.model';
import {ImageProcessingAlgorithms} from '../../app/_algorithms/image-processing.algorithms';
import * as pttJPEG from '../../assets/js/pttjpeg.js';

export const WEB_WORKERS_SUPPORTED_IMAGE_COMPRESSION_QUALITY = 40;
export const WEB_WORKERS_SUPPORTED_IMAGE_COMPRESSION_QUALITY_DOC_ROTATION = 80;

export class IdentificationRecordingWorker {
  private _encoder = new pttJPEG.pttJPEG();

  public addFrame(value: WorkerMessage): WorkerMessage {
    const identifier = value.data.identifier;

    const image = new ImageData(
      new Uint8ClampedArray(value.data.pixels),
      value.data.width,
      value.data.height,
    );

    const blob = this._compress(image,value.data.hasDocumentRotationOrder);

    return new WorkerMessage(value.topic, {identifier: identifier, blob: blob});
  }

  private _compress(image: ImageData,hasDocumentRotationOrder: boolean): Blob {
    const compressQuality = hasDocumentRotationOrder ? WEB_WORKERS_SUPPORTED_IMAGE_COMPRESSION_QUALITY_DOC_ROTATION : WEB_WORKERS_SUPPORTED_IMAGE_COMPRESSION_QUALITY
    const inImage = new this._encoder.pttImage(image);
    const bw = new this._encoder.ByteWriter();
    this._encoder.encode(compressQuality, inImage, bw);
    return ImageProcessingAlgorithms.dataURLtoBlob(bw.getImgUrl());
  }
}
